import { useDroppable } from "@dnd-kit/core"
import { KanbanItem } from "./KanbanItem"
import { IconPlus } from "@tabler/icons-react"
import backgroundImage from "../assets/img/leads_no_data_found.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/free-solid-svg-icons"

export const KanbanColumn = ({
  id,
  title,
  items,
  onAddClick,
  updatingLeads = [],
  onEditLead,
  // onFollowUpLead,
  onDeleteLead,
  onOpenLeadDetails,
  stageColor,
  mainGrant,
  followupGrant,
  highlightId
}) => {
  // Kanban column component for displaying leads in a stage
  const { setNodeRef, isOver } = useDroppable({ id })
  const count = items?.length || 0

  const totalBudget = items?.reduce((sum, item) => {
    try {
      // console.log("item", item)
      const productService = item.product_services
      const individualBudget = productService.reduce((acc, curr) => parseFloat(acc) + parseFloat(curr.budget), 0)
      const total = sum + individualBudget
      return total
    } catch (error) {
      return sum
    }
  }, 0);

  const formattedTotalBudget = totalBudget.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return (
    <div className="kanbanMainDiv" style={{ width: "320px", height: "calc(100vh - 11rem)", }}>

      <div className="mb-0 h-100" style={{ minWidth: '19rem' }}>
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ padding: "11px 17px", background: "#fff", borderRadius: "4px", border: "1px solid #e3e3e3" }}
        >
          <h4 style={{ margin: 0, color: "rgb(46 56 77)", fontSize: "16px", fontWeight: 500 }}>
            {title} - {count}
          </h4>
          <div className="d-flex align-items-center">
            <span>₹{formattedTotalBudget}</span>
            <button
              onClick={() => onAddClick(id)}
              className="plusIconsButtonKanban"
            >
              <FontAwesomeIcon icon={faPlus} />
            </button>
          </div>
        </div>
        <div
          ref={setNodeRef}
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            overflowY: "auto",
            padding: "8px 0px",
            overflowX: "hidden",
            borderRadius: "0px",
            height: "calc(100% - 11%)",
          }}
        >
          {items.map((item) => (
            <KanbanItem
              key={item.lead_id}
              item={item}
              columnId={id}
              isUpdating={updatingLeads.includes(item.lead_id)}
              onEdit={onEditLead}
              // onFollowUp={onFollowUpLead}
              onDelete={onDeleteLead}
              onOpenLeadDetails={onOpenLeadDetails}
              stageColor={stageColor}
              mainGrant={mainGrant}
              followupGrant={followupGrant}
              highlightId ={highlightId || ''}
            />
          ))}
          {items.length === 0 && (
            <div
              className="d-flex flex-column align-items-center justify-content-center h-100"
              style={{
                color: "#6c757d",
                padding: "16px",
                border: isOver ? "2px dashed #4da4ff" : "2px dashed #dee2e6",
                borderRadius: "4px",
                background: "#fff"
              }}
            >
              {isOver ? (
                "Drop lead here"
              ) : (
                <>
                  <img src={backgroundImage || "/placeholder.svg"} alt="" style={{ width: "70%" }} />

                  <p style={{ color: "#038fed", cursor: "pointer" }} onClick={() => onAddClick(id)}>
                    <FontAwesomeIcon icon={faPlus} /> Add Lead
                  </p>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
